import { Env } from '@sanlam-glacier/app-common/types/env/Env.type.js';
import { Provider, atom, createStore } from 'jotai';

export const appStore = createStore();

// Create atoms here based on what you need in the store.
export const envAtom = atom<Env>();

// Set Store with atoms here
export const setAppStore = (environmentConfig: Env) => {
  appStore.set(envAtom, environmentConfig);
};

export const StateProvider = Provider;
